Turbolinks.alert = {};

document.addEventListener('turbolinks:load', () => {
  const turbolinks = window.history?.state?.turbolinks;
  // Scroll to top when there is no restoration data
  if (
    turbolinks?.restorationIdentifier &&
    Object.keys(
      Turbolinks.controller.getRestorationDataForIdentifier(
        turbolinks.restorationIdentifier,
      ) || {},
    ).length === 0
  ) {
    window.scrollTo(0, 0);
  }

  // Notify an alert
  if (Turbolinks.alert['title']) {
    // eslint-disable-next-line no-undef
    alertSnackbar(Turbolinks.alert['title'], Turbolinks.alert['variant']);
  }

  Turbolinks.alert = {};
});

// Add a state to the browser's session history stack using turbolinks
export function pushTurbolinksState(url, title) {
  window.history.pushState({ turbolinks: true, url: url }, title, url);
}

// Set alert attribute to Turbolinks to notify an alert after turbolinks loaded
export function alertAfterTurbolinksLoad(title, variant) {
  Turbolinks.alert = { title: title, variant: variant };
}

global.pushTurbolinksState = pushTurbolinksState;
global.alertAfterTurbolinksLoad = alertAfterTurbolinksLoad;
